import React from 'react';

import { Divider } from '@rbilabs/universal-components';
import { EnvItem, EnvItemBoolean, EnvList, HiddenSection } from 'features/diagnostics/components';

import { useLDContext } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'state/launchdarkly/flags';

const LDFlagsContent = () => {
  const { flags, flagsLoadStatus } = useLDContext();

  const sortedFlagKeys = Object.keys(flags).sort() as LaunchDarklyFlag[];
  const booleanFlagKeys = sortedFlagKeys.filter(key => typeof flags[key] === 'boolean');
  const sortedBooleanFlags = booleanFlagKeys.reduce(
    (acc, cur) => ({ ...acc, [cur]: flags[cur] }),
    {}
  );
  const otherFlagKeys = sortedFlagKeys.filter(key => typeof flags[key] !== 'boolean');
  const sortedStringifiedFlags = otherFlagKeys.reduce(
    (acc, cur) => ({ ...acc, [cur]: JSON.stringify(flags[cur]) }),
    {}
  );
  return (
    <>
      <EnvItem envKey="Flags Load Status" value={flagsLoadStatus} />
      <EnvList
        data={sortedBooleanFlags}
        renderItem={(key, value) => <EnvItemBoolean key={key} envKey={key} value={value} />}
      />
      <Divider marginBottom="$2" marginTop="$2" />
      <EnvList data={sortedStringifiedFlags} />
    </>
  );
};

export const LDFlags = () => (
  <HiddenSection title="LaunchDarkly Flags" content={<LDFlagsContent />} />
);
